import React from 'react';

import {Dialog, Transition} from '@headlessui/react';
import {useMainChapters, useCurrentChapter, useI18n, utils} from 'pageflow-scrolled/frontend';

import styles from './Menu.module.css';

export function Menu({open, close}) {
  const chapters = useMainChapters();
  const currentChapter = useCurrentChapter();
  const {t} = useI18n();

  return (
    <Transition
      appear={true}
      show={open}
      as={React.Fragment}>
      <Dialog onClose={() => { console.log('CLOSE'); close()}}
              className={styles.dialog}>
        <Transition.Child
          enter={styles.fade}
          enterFrom={styles.fadeOut}
          enterTo={styles.fadeIn}
          leave={styles.fade}
          leaveFrom={styles.fadeIn}
          leaveTo={styles.fadeOut}>
          <Dialog.Panel className={styles.panel}>
            <ul className={styles.chapters}>
              {chapters.map(chapter =>
                <li key={chapter.id}>
                  <a href={`#${chapter.chapterSlug}`}
                     aria-current={currentChapter?.id === chapter.id ? 'location' : undefined}
                     className={styles.chapterLink}
                     onClick={close}>
                    {utils.presence(chapter.title) ||
                     t('pageflow_scrolled.public.navigation.chapter', {number: chapter.index + 1})}
                  </a>
                  {!utils.isBlank(chapter.summary) &&
                   <p className={styles.summary}
                      dangerouslySetInnerHTML={{__html: chapter.summary}} />}
                </li>
              )}
            </ul>
          </Dialog.Panel>
        </Transition.Child>
      </Dialog>
    </Transition>
);
}
